module.exports = __webpack_public_path__ + "static/unicorn3-b28afaa198b2cb6af73321b9ee338e9c.png";